<template>
  <div>
    <b-modal ref="privacy-modal" id="privacy-modal" size="lg" hide-footer>
      <h5 class="text-primary mb-4">{{ trans("legend.privacy_options") }}</h5>

      <div class="row">
        <div class="col-md-3 d-flex justify-content-center align-items-center">
          <privacy-alert buttonSize="sm">
            <img src="/images/icon_private.svg" width="24px" class="pr-1" /> {{ companyName }}
          </privacy-alert>
        </div>
        <div class="col-md-9">
          {{
            transChoice("community.your_name_vissible", companyName, { companyName: companyName })
          }}
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-3 d-flex justify-content-center align-items-center">
          <privacy-alert buttonSize="sm">
            <img src="/images/moderation.svg" height="21px" />
          </privacy-alert>
        </div>
        <div class="col-md-9">
          {{ transChoice("community.who_moderates", companyName, { companyName: companyName })
          }}<br />

          {{
            transChoice("community.managers_can_remove", companyName, { companyName: companyName })
          }}<br />
          <br />
        </div>
      </div>
      <div class="d-flex justify-content-end mt-5">
        <b-button
          variant="light"
          class="mr-2"
          target="_blank"
          :href="trans('community.privacy_link')"
        >
          {{ trans("community.go_to_policy") }}
        </b-button>
        <b-button variant="secondary" @click="hideModal">
          {{ trans("community.close_popup") }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PrivacyAlert from "../molecules/PrivacyAlert";

export default {
  name: "PrivacyModal",
  components: { PrivacyAlert },
  props: {
    companyName: String,
  },
  methods: {
    showModal() {
      this.$bvModal.show("privacy-modal");
    },
    hideModal() {
      this.$bvModal.hide("privacy-modal");
    },
  },
  mounted() {
    if (localStorage.getItem("sharedRoomwasVisited") === null) {
      this.showModal();
    }
    localStorage.setItem("sharedRoomwasVisited", "1");
  },
};
</script>

<style lang="scss">
#privacy-modal {
  .modal-body {
    padding: 0 ($spacer * 1.5) ($spacer * 1.5);
  }
  .modal-header {
    padding-bottom: 0;
  }
}
</style>
